import { prop } from 'ramda';
import { useCallback } from 'react';
import { getCleanUrl } from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';

export const useClearIdsInPath = () => {
    const dynamicRoutingUrls = useAppSelector(prop('dynamicRoutingUrls'));

    return useCallback((pathname) => {
        const cleanUrl = getCleanUrl(pathname);

        return dynamicRoutingUrls.find(page => cleanUrl.startsWith(`${page}/`) || cleanUrl === page)
            || pathname;
    }, [dynamicRoutingUrls]);
};
